var _rect, _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.2139,
    y: 5.42871,
    width: 9.50058,
    height: 9.50058,
    rx: 3.39306,
    fill: "#2D3D95",
    stroke: "#2D3D95",
    strokeWidth: 2.03584
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_0_1254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6073 17.9834C20.1712 17.9834 18.1963 19.9583 18.1963 22.3944V25.1088C18.1963 27.5449 20.1712 29.5198 22.6073 29.5198H25.3217C27.7578 29.5198 29.7327 27.5449 29.7327 25.1088V22.3944C29.7327 19.9583 27.7578 17.9834 25.3217 17.9834H22.6073Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6073 17.9834C20.1712 17.9834 18.1963 19.9583 18.1963 22.3944V25.1088C18.1963 27.5449 20.1712 29.5198 22.6073 29.5198H25.3217C27.7578 29.5198 29.7327 27.5449 29.7327 25.1088V22.3944C29.7327 19.9583 27.7578 17.9834 25.3217 17.9834H22.6073Z",
    fill: "url(#paint0_linear_0_1254)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5356 22.3944C18.5356 20.1457 20.3585 18.3227 22.6073 18.3227V17.6441C19.9838 17.6441 17.857 19.7709 17.857 22.3944H18.5356ZM18.5356 25.1088V22.3944H17.857V25.1088H18.5356ZM22.6073 29.1805C20.3585 29.1805 18.5356 27.3576 18.5356 25.1088H17.857C17.857 27.7323 19.9838 29.8591 22.6073 29.8591V29.1805ZM25.3217 29.1805H22.6073V29.8591H25.3217V29.1805ZM29.3934 25.1088C29.3934 27.3576 27.5704 29.1805 25.3217 29.1805V29.8591C27.9452 29.8591 30.072 27.7323 30.072 25.1088H29.3934ZM29.3934 22.3944V25.1088H30.072V22.3944H29.3934ZM25.3217 18.3227C27.5704 18.3227 29.3934 20.1457 29.3934 22.3944H30.072C30.072 19.7709 27.9452 17.6441 25.3217 17.6441V18.3227ZM22.6073 18.3227H25.3217V17.6441H22.6073V18.3227Z",
    fill: "url(#paint1_linear_0_1254)",
    fillOpacity: 0.7,
    mask: "url(#path-2-inside-1_0_1254)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_0_1254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03501 17.9834C6.59889 17.9834 4.62402 19.9583 4.62402 22.3944V25.1088C4.62402 27.5449 6.59889 29.5198 9.03501 29.5198H11.7495C14.1856 29.5198 16.1604 27.5449 16.1604 25.1088V22.3944C16.1604 19.9583 14.1856 17.9834 11.7495 17.9834H9.03501Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03501 17.9834C6.59889 17.9834 4.62402 19.9583 4.62402 22.3944V25.1088C4.62402 27.5449 6.59889 29.5198 9.03501 29.5198H11.7495C14.1856 29.5198 16.1604 27.5449 16.1604 25.1088V22.3944C16.1604 19.9583 14.1856 17.9834 11.7495 17.9834H9.03501Z",
    fill: "url(#paint2_linear_0_1254)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96333 22.3944C4.96333 20.1457 6.78628 18.3227 9.03501 18.3227V17.6441C6.41149 17.6441 4.28472 19.7709 4.28472 22.3944H4.96333ZM4.96333 25.1088V22.3944H4.28472V25.1088H4.96333ZM9.03501 29.1805C6.78628 29.1805 4.96333 27.3576 4.96333 25.1088H4.28472C4.28472 27.7323 6.41149 29.8591 9.03501 29.8591V29.1805ZM11.7495 29.1805H9.03501V29.8591H11.7495V29.1805ZM15.8211 25.1088C15.8211 27.3576 13.9982 29.1805 11.7495 29.1805V29.8591C14.373 29.8591 16.4997 27.7323 16.4997 25.1088H15.8211ZM15.8211 22.3944V25.1088H16.4997V22.3944H15.8211ZM11.7495 18.3227C13.9982 18.3227 15.8211 20.1457 15.8211 22.3944H16.4997C16.4997 19.7709 14.373 17.6441 11.7495 17.6441V18.3227ZM9.03501 18.3227H11.7495V17.6441H9.03501V18.3227Z",
    fill: "url(#paint3_linear_0_1254)",
    fillOpacity: 0.7,
    mask: "url(#path-4-inside-2_0_1254)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3_0_1254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03501 4.41113C6.59889 4.41113 4.62402 6.386 4.62402 8.82212V11.5366C4.62402 13.9727 6.59889 15.9475 9.03501 15.9475H11.7495C14.1856 15.9475 16.1604 13.9727 16.1604 11.5366V8.82212C16.1604 6.386 14.1856 4.41113 11.7495 4.41113H9.03501Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03501 4.41113C6.59889 4.41113 4.62402 6.386 4.62402 8.82212V11.5366C4.62402 13.9727 6.59889 15.9475 9.03501 15.9475H11.7495C14.1856 15.9475 16.1604 13.9727 16.1604 11.5366V8.82212C16.1604 6.386 14.1856 4.41113 11.7495 4.41113H9.03501Z",
    fill: "url(#paint4_linear_0_1254)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96333 8.82212C4.96333 6.57339 6.78628 4.75044 9.03501 4.75044V4.07183C6.41149 4.07183 4.28472 6.1986 4.28472 8.82212H4.96333ZM4.96333 11.5366V8.82212H4.28472V11.5366H4.96333ZM9.03501 15.6082C6.78628 15.6082 4.96333 13.7853 4.96333 11.5366H4.28472C4.28472 14.1601 6.41149 16.2869 9.03501 16.2869V15.6082ZM11.7495 15.6082H9.03501V16.2869H11.7495V15.6082ZM15.8211 11.5366C15.8211 13.7853 13.9982 15.6082 11.7495 15.6082V16.2869C14.373 16.2869 16.4997 14.1601 16.4997 11.5366H15.8211ZM15.8211 8.82212V11.5366H16.4997V8.82212H15.8211ZM11.7495 4.75044C13.9982 4.75044 15.8211 6.57339 15.8211 8.82212H16.4997C16.4997 6.1986 14.373 4.07183 11.7495 4.07183V4.75044ZM9.03501 4.75044H11.7495V4.07183H9.03501V4.75044Z",
    fill: "url(#paint5_linear_0_1254)",
    fillOpacity: 0.7,
    mask: "url(#path-6-inside-3_0_1254)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_0_1254",
    x: 14.1963,
    y: 13.9834,
    width: 19.5361,
    height: 19.5366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1254"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_0_1254",
    result: "effect2_dropShadow_0_1254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_1254",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_0_1254"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bdi_0_1254",
    x: 0.624023,
    y: 13.9834,
    width: 19.5361,
    height: 19.5366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1254"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_0_1254",
    result: "effect2_dropShadow_0_1254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_1254",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_0_1254"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bdi_0_1254",
    x: 0.624023,
    y: 0.411133,
    width: 19.5361,
    height: 19.5366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1254"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_0_1254",
    result: "effect2_dropShadow_0_1254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_1254",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_0_1254"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1254",
    x1: 14.447,
    y1: 13.3688,
    x2: 35.7893,
    y2: 32.4039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344EA6",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#587EFF",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#829EFF",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1254",
    x1: 18.4847,
    y1: 19.7139,
    x2: 28.5791,
    y2: 28.3662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1254",
    x1: 0.874688,
    y1: 13.3688,
    x2: 22.2171,
    y2: 32.4039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344EA6",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#587EFF",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#829EFF",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1254",
    x1: 4.91243,
    y1: 19.7139,
    x2: 15.0068,
    y2: 28.3662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1254",
    x1: 0.874688,
    y1: -0.203434,
    x2: 22.2171,
    y2: 18.8317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344EA6",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#587EFF",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#829EFF",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1254",
    x1: 4.91243,
    y1: 6.1416,
    x2: 15.0068,
    y2: 14.7939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.dcb5db5b6699085554d498d762448f2e.svg";
export { ForwardRef as ReactComponent };